module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "img-list"
  }, [_vm._l((_vm.imgList), function(item, index) {
    return _c('div', {
      staticClass: "img-box g-adaptimg",
      on: {
        "click": function($event) {
          return _vm.lookimg(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delImage(index)
        }
      }
    })])
  }), _vm._v(" "), (!_vm.isWrite) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList.length < _vm.length),
      expression: "imgList.length<length"
    }],
    class: {
      'upload-box': true, 'reUpLoad': _vm.isReUp
    }
  }, [_c('i', {
    staticClass: "iconfont icon-zengjia"
  }), _vm._v(" "), _c('input', {
    staticClass: "upload-input",
    attrs: {
      "id": "files",
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isWrite) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList.length < _vm.length),
      expression: "imgList.length<length"
    }],
    class: {
      'isWrite': true, 'reUpLoad': _vm.isReUp
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tupian"
  }), _vm._v(" "), _c('input', {
    staticClass: "upload-input",
    attrs: {
      "id": "files",
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "g-members-choose-box"
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-82bb80da"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/addimg.vue
// module id = 226
// module chunks = 49